module.exports = __webpack_public_path__ + "static/media/marca_cabezal.ef254c16.png";